import Vue from 'vue';

const myPlugin = Vue.prototype.$getImageCapUrl = function(state, plan_id, cap_rating){

	let url = state.config.s3ResourceHost + "/images/cap-ratings";

	if(plan_id == 3 || plan_id == 166 || plan_id == 31){
		url = url + "/rating-caps-FDIC.svg";
	}else{
		url = url + `/rating-caps-${cap_rating}.svg`;
	}

	return url
}

Vue.use(myPlugin)

